import { render, staticRenderFns } from "./OverRaySendPicture.vue?vue&type=template&id=6585c665&scoped=true&"
import script from "./OverRaySendPicture.vue?vue&type=script&lang=ts&"
export * from "./OverRaySendPicture.vue?vue&type=script&lang=ts&"
import style0 from "./OverRaySendPicture.vue?vue&type=style&index=0&id=6585c665&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6585c665",
  null
  
)

export default component.exports